export default __webpack_public_path__ + "static/media/managing-conflict.d4c7e133.svg";